module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-66.863ce654.gif";